import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"
import {
  BackofficeRestMutations,
  UpdatePaymentSchedulePayload,
} from "@/api/backofficeRest/mutations"
import { CreatePaymentScheduleResponse } from "@/api/backofficeRest/generated/model"
import { useCurrentAccountStore } from "@/stores/currentAccount"
import { formatDateTimeStartOfDayUtc } from "@/helpers/dateHelper"
import { IUpdateSchedule } from "./PaymentMutator.types"

export interface IPaymentMutator {
  updateSchedule(): MutationResult<
    IUpdateSchedule,
    CreatePaymentScheduleResponse
  >
}

class PaymentMutatorClass implements IPaymentMutator {
  updateSchedule(): MutationResult<
    IUpdateSchedule,
    CreatePaymentScheduleResponse
  > {
    return useMutation({
      ...BackofficeRestMutations.payments.updatePaymentSchedule(),
      serializerFn: (data: IUpdateSchedule): UpdatePaymentSchedulePayload => {
        const billingAccountId = useCurrentAccountStore().coreId.data
        if (!billingAccountId) throw new Error("Missing coreId")
        return {
          billingAccountId,
          body: {
            fromDate: formatDateTimeStartOfDayUtc(data.fromDt),
            alignmentDate: formatDateTimeStartOfDayUtc(data.firstPaymentDate),
            seasonalPayment: data.seasonal,
            amountInPounds: Number(data.equalPaymentAmount),
          },
        }
      },
    })
  }
}

export const PaymentMutator = new PaymentMutatorClass()
